"use client";

import { useState, forwardRef, useRef } from "react";

import {
  ShareModal,
  useCopyToClipBoard,
  ShareContent,
} from "@JohnLewisPartnership/jl-design-system/dist/components/share-modal/ShareModal";
import { SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED } from "../../../../constants/constants";

type ShareContentProps = { copied: boolean; copy: () => void; url: string };

const ForwardingShareContent = forwardRef(function content(
  { copied, copy, url }: ShareContentProps,
  ref,
) {
  return (
    <ShareContent
      copied={copied}
      inputElement={ref}
      handleCopy={copy}
      url={url}
    />
  );
});

type Props = {
  isActiveProduct: boolean;
  title: string;
  shareUrl: string;
  shareImage: string;
  isVariantSelected: boolean;
};

export const Share = ({
  isActiveProduct,
  title,
  shareUrl,
  shareImage,
  isVariantSelected,
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const inputRef = useRef(null);
  const [copied, { copy, resetCopyState }] = useCopyToClipBoard(inputRef);

  const handleShare = () => {
    if (!isVariantSelected) {
      window.dispatchEvent(
        new CustomEvent(SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED),
      );
      return;
    }
    if (navigator.share) {
      navigator.share({
        title: title,
        url: shareUrl,
      });
    } else {
      setModalOpen(true);
    }
  };

  const closeModal = () => {
    resetCopyState();
    setModalOpen(false);
  };

  return isActiveProduct ? (
    <ShareModal
      url={shareUrl}
      title={title}
      image={shareImage}
      shareRoot="page-root"
      handleShare={handleShare}
      isModalOpen={modalOpen}
      closeModal={closeModal}
      shareContent={
        <ForwardingShareContent
          copied={copied}
          ref={inputRef}
          copy={copy}
          url={shareUrl}
        />
      }
    />
  ) : null;
};
